module.exports = __webpack_public_path__ + "img/b_11.1561f81e.jpg";